import { axios } from '@/utils/request_tradingAdd'

const createOrUpdate = (params) => {
    return axios({
        url: '/app-api/stock/strategy-api/strategyPool/createOrUpdate',
        method: 'post',
        data: params
      })
}

const tradingRules = (params) => {
    return axios({
        url: '/app-api/stock/strategy-api/strategyPool/get/trading_rules',
        method: 'post',
        data: params
      })
}

// /app-api/stock/strategy-api/strategyPool/upper_lower_shelves   accountId策略id  upperLowerShelves1 上/2 下架

const upperLowerShelves = (params) => {
    return axios({
        url: '/app-api/stock/strategy-api/strategyPool/upper_lower_shelves',
        method: 'post',
        data: params
      })
}


// /app-api/stock/strategy-api/strategyPool/list
const strategyPoolList = (params) => {
    return axios({
        url: '/app-api/stock/strategy-api/strategyPool/list',
        method: 'post',
        data: params
      })
}
export default {
    
    createOrUpdate,
    tradingRules,
    upperLowerShelves,
    strategyPoolList
   
}